module.exports = __webpack_public_path__ + "static/logo-7d83a79d7891928a924473162df71cd9.jpg";